import { IAdminSettings } from 'library/Pages';
import {
  getArticleUrlPattern,
  getPreviewUrlPattern,
  getSectionUrlPattern,
} from 'utilities';

// btoa() zvládne iba Latin-1 – názov webu môže obsahovať napr. "Š" alebo "Ž".
// Znaky mimo Latin-1 preto zapíšeme ako JSON escape (\uXXXX), ktoré cms.ui
// bez akejkoľvek zmeny dekóduje cez atob() + JSON.parse().
const encodeSettings = (json: string) =>
  btoa(
    json.replace(
      /[\u0100-\uffff]/g,
      c => `\\u${c.charCodeAt(0).toString(16).padStart(4, '0')}`,
    ),
  );

const CMS_APP_BASE_URL =
  process.env.REACT_APP_CMS_APP_BASE_URL ?? 'https://cms.sportnet.online';

const getCmsUrl = (
  appId: string,
  appSpace: string,
  contentDivider: string,
  settings: IAdminSettings,
  siteName?: string,
) => {
  const previewUrlPattern = getPreviewUrlPattern(settings);
  const articleUrlPattern = getArticleUrlPattern(settings);
  const sectionUrlPattern = getSectionUrlPattern(settings);
  const articleLayouts = settings?.articleLayouts || [];
  const parentUrl = '';
  const settingsParamValue = encodeSettings(
    JSON.stringify({
      parentUrl,
      previewUrlPattern,
      articleUrlPattern,
      sectionUrlPattern,
      articleLayouts,
      domain: settings?.domain || undefined,
      siteName: siteName || undefined,
    }),
  );
  const searchParams = new URLSearchParams();
  searchParams.set('settings', settingsParamValue);

  return `${CMS_APP_BASE_URL}/app/${appId}/${appSpace}/${contentDivider}?${searchParams.toString()}`;
};

export default getCmsUrl;
